// import { mdiChevronRight } from '@mdi/js';
// import Icon from '@mdi/react';
import React from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import the from '../../assets/the.png';
import useWindowDimensions from '../../hooks/WindowDimensions';
import './Sidebar.scss';

const sidebars = [
  { title: 'عضویت کاربر', url: '/UserManager' },
  { title: 'دریاچه', url: '/Lake' },
  { title: 'ایستگاه هیدرومتریک', url: '/Hydrometric' },
  { title: 'ایستگاه سینوپتیک', url: '/Synoptic' },
  { title: 'سد', url: '/Dam' },
  { title: 'آبخوان', url: '/Aquifer' },
  { title: 'ایستگاه هواشناسی', url: '/WeatherStation' },
  { title: 'حوضه آبریز', url: '/Watershed' },
];

const Sidebar = (props) => {
  const [sidebar] = useState(true);
  // const [sidebar, setSidebar] = useState(true);
  const { children } = props;
  const { width } = useWindowDimensions();

  return (
    <div className='sidebar'>
      <div style={{ width: width - 250, height: '100%' }}>{children}</div>

      <div>
        <div style={{ right: sidebar ? '7px' : '-225px' }}>
          {/* <div>
          <Icon path={mdiChevronRight} size={2} title='toggle' />
        </div> */}
          <div className='center'>
            <img src={the} alt='the' />

            <div>خانه / پنل ادمین</div>
          </div>

          <ul>
            {sidebars.map((e) => (
              <NavLink key={e.url} to={e.url}>
                {e.title}
              </NavLink>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
